import type { RedirectLoginOptions } from "@auth0/auth0-react"
import { clearBootSnapshot } from "boot/snapshot"
import { isLoginCallback } from "./loginCallback"

/** The Auth0 error code on an SDK error (`error.error`), or "". */
export const authErrorCode = (error: unknown) =>
  typeof error === "object" && error !== null && "error" in error ? String((error as { error: unknown }).error) : ""

/**
 * The SDK cannot mint a token without the user signing in again: the Auth0
 * session is gone (login_required — the SDK then also signs out locally, so
 * useAuth0() flips to signed out), or there is no refresh token to renew with
 * and no silent-auth fallback (missing_refresh_token, localhost).
 */
export const isSignInRequired = (error: unknown) => ["login_required", "missing_refresh_token"].includes(authErrorCode(error))

export { isLoginCallback }

// This page load came back from the login page (read at startup, before the
// SDK strips the parameters): its tokens are brand new.
export const ARRIVED_FROM_LOGIN = typeof window !== "undefined" && isLoginCallback(window.location.search)

let signingIn = false

/** Send the user to sign in and back to this page — once per page load. */
export const signInAgain = (loginWithRedirect: (options?: RedirectLoginOptions) => Promise<void>) => {
  if (signingIn) return
  signingIn = true
  // whoever signs in next may be someone else: don't boot them into this app
  clearBootSnapshot()
  void loginWithRedirect({ appState: { returnTo: `${window.location.pathname}${window.location.search}` } })
}

// tests only
export const resetSignInAgain = () => {
  signingIn = false
}
